import React, { Component, Fragment } from 'react';
import withRouter from 'components/components/common/withRouter';
import TransHelper from 'components/common/translations/TransHelper';
import includes from 'lodash/includes';

class PageBackground extends Component {

  canRenderBackground = () => {
    var pathname = this.props.location.pathname;
    var routeName = TransHelper.findWholeRouteKey(this.props.locale, pathname);
    var allowedUrls = [
      'routes.url.booking',
      'routes.url.flights',
      'routes.url.kidsSafety',
      'routes.url.userData',
      'routes.url.summary',
    ];
    return includes(allowedUrls, routeName);
  }

  render() {
    if (!this.canRenderBackground()) {
      return null;
    }
    return (
      <div className='page--bg'></div>
    )
  }
}

export default withRouter(PageBackground);
